import OptimizationApi from '@/api/optimization'

export class OptimizationRepository {
  static async getOptimizationGoal(insertionOrderId, menuId, goalType) {
    const res = await OptimizationApi.get(insertionOrderId, menuId, goalType)
    return res
  }
}
